import { GO_TO_BASKET } from './constant';

export const goToBasket = () => ({
    type: GO_TO_BASKET,
} as const);

export type PriceSectionActions = ReturnType<typeof goToBasket>;
